function Diamond({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path
        d="M11.9999 20.6057L2.29785 8.9615L5.1536 3.25H18.8461L21.7019 8.9615L11.9999 20.6057ZM9.22085 8.25H14.7788L13.0286 4.75H10.9711L9.22085 8.25ZM11.2499 17.3673V9.75H4.92085L11.2499 17.3673ZM12.7499 17.3673L19.0788 9.75H12.7499V17.3673ZM16.4461 8.25H19.6539L17.9036 4.75H14.6959L16.4461 8.25ZM4.34585 8.25H7.5536L9.30385 4.75H6.0961L4.34585 8.25Z"
        fill="#757575"
      />
    </svg>
  );
}

export default Diamond;
